import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { hiddenDown, hiddenUp } from '@/theme';

export const PerkWrapper = styled(Box)<{ $nbPerks: number }>`
  ${({ $nbPerks, theme }) => css`
    width: ${$nbPerks > 2 ? `${100 / $nbPerks}%` : '33%'};

    ${$nbPerks <= 2 &&
    css`
      width: ${100 / $nbPerks}%;
    `}
    * {
      transition: ${theme.transitions.create('color')};
    }

    &:hover * {
      color: ${theme.colors.primary};
    }
  `}
`;

export const Text = styled(Box)`
  text-transform: uppercase;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.secondary};
  `};
`;

export interface WrapperProps {
  mdHidden?: boolean;
  mdVisible?: boolean;
  variant: 'desktop' | 'mobile';
}

export const Wrapper = styled(Flex)<WrapperProps>`
  padding-top: ${({ theme }) => theme.spacing(2.5)};

  ${({ mdHidden, mdVisible, theme, variant }) => css`
    ${variant === 'mobile' &&
    css`
      overflow-x: auto;
      justify-content: space-evenly;
      gap: ${theme.spacing(1)};
      scrollbar-width: none;
      -ms-overflow-style: none;
    `}
    &::-webkit-scrollbar {
      display: none;
    }

    ${mdHidden && hiddenUp('md')}
    ${mdVisible && hiddenDown('md')}
    
    ${theme.media.md.up} {
      margin: 0;
      justify-content: flex-start;
      overflow: hidden;
    }
  `}
`;
